import { combineReducers } from "@reduxjs/toolkit";
import auth from "./auth";
import app from "./app";
import data from "./data";
import features from "./features";

export default combineReducers({ auth, app, data, features });
